var map = {
	"./404_images/404.png": "./src/assets/404_images/404.png",
	"./404_images/404_cloud.png": "./src/assets/404_images/404_cloud.png",
	"./Line_1.png": "./src/assets/Line_1.png",
	"./Line_2.png": "./src/assets/Line_2.png",
	"./Line_3.png": "./src/assets/Line_3.png",
	"./caidan.png": "./src/assets/caidan.png",
	"./call.png": "./src/assets/call.png",
	"./chatservice.png": "./src/assets/chatservice.png",
	"./check.png": "./src/assets/check.png",
	"./compliance/tool.png": "./src/assets/compliance/tool.png",
	"./dalibao.png": "./src/assets/dalibao.png",
	"./dalibaohuodong.png": "./src/assets/dalibaohuodong.png",
	"./dosce.png": "./src/assets/dosce.png",
	"./fundaccount.png": "./src/assets/fundaccount.png",
	"./fundamount.png": "./src/assets/fundamount.png",
	"./fundcard.png": "./src/assets/fundcard.png",
	"./icon_detail_status.png": "./src/assets/icon_detail_status.png",
	"./icon_detail_status1.png": "./src/assets/icon_detail_status1.png",
	"./invoiceblue.png": "./src/assets/invoiceblue.png",
	"./invoiceinfo.png": "./src/assets/invoiceinfo.png",
	"./invoicered.png": "./src/assets/invoicered.png",
	"./lianjie.png": "./src/assets/lianjie.png",
	"./login/agree.png": "./src/assets/login/agree.png",
	"./login/close-eyes.png": "./src/assets/login/close-eyes.png",
	"./login/dunpai.png": "./src/assets/login/dunpai.png",
	"./login/eyes.png": "./src/assets/login/eyes.png",
	"./login/people.png": "./src/assets/login/people.png",
	"./login/shouji.png": "./src/assets/login/shouji.png",
	"./login/suo.png": "./src/assets/login/suo.png",
	"./logo-chunbo.png": "./src/assets/logo-chunbo.png",
	"./logo.png": "./src/assets/logo.png",
	"./number1.png": "./src/assets/number1.png",
	"./number2.png": "./src/assets/number2.png",
	"./number3.png": "./src/assets/number3.png",
	"./number4.png": "./src/assets/number4.png",
	"./payStep1.png": "./src/assets/payStep1.png",
	"./payStep2.png": "./src/assets/payStep2.png",
	"./payStep3.png": "./src/assets/payStep3.png",
	"./payaddress.png": "./src/assets/payaddress.png",
	"./paysuccess.png": "./src/assets/paysuccess.png",
	"./public/back.png": "./src/assets/public/back.png",
	"./public/g1.png": "./src/assets/public/g1.png",
	"./public/g2.png": "./src/assets/public/g2.png",
	"./public/g3.png": "./src/assets/public/g3.png",
	"./public/g4.png": "./src/assets/public/g4.png",
	"./public/icon-small.png": "./src/assets/public/icon-small.png",
	"./public/search_icon.png": "./src/assets/public/search_icon.png",
	"./public/type_bg.png": "./src/assets/public/type_bg.png",
	"./reject.png": "./src/assets/reject.png",
	"./shangzhang.png": "./src/assets/shangzhang.png",
	"./shop.png": "./src/assets/shop.png",
	"./storeHead.jpg": "./src/assets/storeHead.jpg",
	"./success.png": "./src/assets/success.png",
	"./uncheck.png": "./src/assets/uncheck.png",
	"./wait-2.png": "./src/assets/wait-2.png",
	"./wait.png": "./src/assets/wait.png",
	"./xiadie.png": "./src/assets/xiadie.png",
	"./zhiding.png": "./src/assets/zhiding.png",
	"./zizhi/gongsijujue.png": "./src/assets/zizhi/gongsijujue.png",
	"./zizhi/gongsitongguo.png": "./src/assets/zizhi/gongsitongguo.png",
	"./zizhi/gongsitongguo1.png": "./src/assets/zizhi/gongsitongguo1.png",
	"./zizhi/qiyejujue.png": "./src/assets/zizhi/qiyejujue.png",
	"./zizhi/qiyetongguo.png": "./src/assets/zizhi/qiyetongguo.png",
	"./zizhi/qiyetongguo1.png": "./src/assets/zizhi/qiyetongguo1.png",
	"./zizhi/yunyingjujue.png": "./src/assets/zizhi/yunyingjujue.png",
	"./zizhi/yunyingtongguo.png": "./src/assets/zizhi/yunyingtongguo.png",
	"./zizhi/yunyingtongguo1.png": "./src/assets/zizhi/yunyingtongguo1.png",
	"./zizhi/zhensuojujue.png": "./src/assets/zizhi/zhensuojujue.png",
	"./zizhi/zhensuotongguo.png": "./src/assets/zizhi/zhensuotongguo.png",
	"./zizhi/zhensuotongguo1.png": "./src/assets/zizhi/zhensuotongguo1.png",
	"./zz/add-icon.png": "./src/assets/zz/add-icon.png",
	"./zz/del-icon.png": "./src/assets/zz/del-icon.png",
	"./zz/fail-icon.png": "./src/assets/zz/fail-icon.png",
	"./zz/icon_detail_status.png": "./src/assets/zz/icon_detail_status.png",
	"./zz/paysuccess.png": "./src/assets/zz/paysuccess.png",
	"./zz/see-icon.png": "./src/assets/zz/see-icon.png",
	"./zz/selected-icon.png": "./src/assets/zz/selected-icon.png",
	"./zz/top-tip-pic.png": "./src/assets/zz/top-tip-pic.png",
	"./选中.png": "./src/assets/选中.png",
	"./选中1.png": "./src/assets/选中1.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";